import { AGE_GATE_BLOCK_UNDER } from './constants';
import type { AgeGateDecision, AgeGatePlatformSignal } from './types';

export function decideAgeGate(signal: AgeGatePlatformSignal): AgeGateDecision {
  switch (true) {
    case signal.region === 'CA':
    case signal.ageRulesApply === false:
    case signal.signalState !== 'ok':
      return 'allow';
    case signal.significantChangeStatus === 'DECLINED':
      return 'block';
    case signal.ageSignalsStatus === 'NOT_SHARED':
    case signal.ageSignalsStatus === 'VERIFICATION_REQUIRED':
      return 'allow';
    case signal.upperBound != null && signal.upperBound < AGE_GATE_BLOCK_UNDER:
      return 'block';
    default:
      return 'allow';
  }
}
